export const REVALIDATE_BLOGS = (params) => `/api-handlers/revalidate-blogs?secret=${params?.secret}&slug=${params.slug}`;

export const LOGOUT_URL = (params) => `/api-handlers/logout`;